'use strict';

angular.module('atex.dam').directive('tooltip', function() {
  return {
    link: function(scope, element, attrs) {
      $(element).addClass("tooltip-trigger").tooltip({
        container: 'body',
        placement: 'top',
        trigger: 'click'
      });
    }
  };
});
